import { render, staticRenderFns } from "./Persongroup.vue?vue&type=template&id=317b4eb8&scoped=true"
import script from "./Persongroup.vue?vue&type=script&lang=js"
export * from "./Persongroup.vue?vue&type=script&lang=js"
import style0 from "./Persongroup.vue?vue&type=style&index=0&id=317b4eb8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317b4eb8",
  null
  
)

export default component.exports